export const ContactInfo = `If you have questions about this Policy or wish to exercise any of your rights, please contact us at:
    • Dos Apes, LLC
• Email: Support@HealioSpace.com
• Address: Austin, TX, USA`;
